module.exports = __webpack_public_path__ + "static/media/p.e352dfee.png";